var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, isValidElement } from 'react';
import { Text } from '../Text';
import { checkboxDefaultProps } from './props';
import * as S from './styles';
import { XCircle } from '@olxbr/ds-icons';
const CHECKBOX_ACESSIBILITY_ERROR = 'Se o checkbox não possuir um label textual descritivo é necessário informar o atributo "aria-label"';
const CHECKBOX_INVALID_LABEL_ERROR = 'A prop label precisa ser do tipo "ReactNode"';
const CheckIcon = ({ visibility }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", visibility: visibility, width: "12", height: "8", viewBox: "0 0 12 8" },
    React.createElement("path", { d: "M11.0744 0.258162C10.7293 -0.0860539 10.1698 -0.086054 9.8247 0.258162L4.19463 5.87399L2.175 3.85946C1.82991 3.51525 1.27041 3.51525 0.925321 3.85946C0.580232 4.20368 0.580231 4.76176 0.92532 5.10598L3.56785 7.74182C3.8518 8.02505 4.28093 8.07523 4.61633 7.89234C4.6917 7.85231 4.76248 7.80061 4.82599 7.73726L11.0744 1.50468C11.4195 1.16046 11.4195 0.602378 11.0744 0.258162Z" })));
const renderLabel = ({ label, size = checkboxDefaultProps.size }) => {
    if (!label)
        return null;
    if (typeof label === 'string') {
        const LabelText = size === 'medium' ? Text.BodyMedium : Text.BodySmall;
        return (React.createElement(LabelText, { marginLeft: size === 'medium' ? '--spacing-1' : '--spacing-0-5', color: "--color-neutral-130" }, label));
    }
    if (isValidElement(label))
        return React.createElement(S.LabelWrapper, { size: size }, label);
    throw new Error(CHECKBOX_INVALID_LABEL_ERROR);
};
export const Checkbox = forwardRef((props, ref) => {
    const { size = checkboxDefaultProps.size, label, checked, disabled, 'aria-label': ariaLabel, errorMessage } = props, restProps = __rest(props, ["size", "label", "checked", "disabled", 'aria-label', "errorMessage"]);
    if (!label && !ariaLabel)
        throw new Error(CHECKBOX_ACESSIBILITY_ERROR);
    return (React.createElement(React.Fragment, null,
        React.createElement(S.ContainerLabel, { "data-ds-component": "DS-Checkbox", disabled: disabled },
            React.createElement(S.SpanInput, { size: size },
                React.createElement(S.NativeInput, Object.assign({ "aria-label": ariaLabel, ref: ref, checked: checked, disabled: disabled, "aria-invalid": !!errorMessage, type: "checkbox" }, (errorMessage && { 'aria-describedby': 'ds-checkbox-errormessage' }), restProps)),
                React.createElement(S.CheckboxInputStylized, { hasError: errorMessage ? true : false, checked: checked, size: size },
                    React.createElement(CheckIcon, { visibility: checked ? 'visible' : 'hidden' }))),
            renderLabel(props)),
        label && errorMessage && (React.createElement(S.ErrorMessageWrapper, null,
            React.createElement(XCircle, { size: "16px" }),
            React.createElement(Text.Caption, { id: "ds-checkbox-errormessage", role: "alert", marginTop: "--spacing-0-25" }, errorMessage)))));
});
Checkbox.defaultProps = checkboxDefaultProps;
Checkbox.displayName = 'Checkbox';
